import { SelectSearchField } from 'components'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select lead source.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const LeadSourceSelectSearchField = ({
  name,
  label,
  required,
  userId,
  productIdWithSellingPriceList,
  ...props
}) => {

  const { setFieldError, setFieldTouched, setFieldValue } = useFormikContext()

  const leadSourceList = [
    {
      label: "Website",
      value: "Website",
    },
    {
      label: "Instagram",
      value: "Instagram",
    },
    {
      label: "Google",
      value: "Google",
    },
    {
      label: "TikTok",
      value: "TikTok",
    },
    {
      label: "Friend",
      value: "Friend",
    },
    {
      label: "Referral",
      value: "Referral",
    },
    {
      label: "Passing-By",
      value: "Passing-By",
    },
    {
      label: "Event",
      value: "Event",
    },
    {
      label: "Exhibition",
      value: "Exhibition",
    },
    {
      label: "Billboard",
      value: "Billboard",
    },
    {
      label: "Other",
      value: "Other",
    },
  ]
  const [ filteredLeadSourceList, setFilteredLeadSourceList ] = useState(leadSourceList)
  const [ isSearchLoading, setSearchLoading ] = useState(false)

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    option.label
  )

  // handler to search
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    setFilteredLeadSourceByQuery(leadSourceList, searchText)
  }
  const setFilteredLeadSourceByQuery = (leadSourceList, searchText) => {
    if(searchText){
      setFilteredLeadSourceList(
        leadSourceList.filter(o => o.label.toLowerCase().includes(searchText))
      )
    }else{
      setFilteredLeadSourceList(leadSourceList)
    }
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search...'
      dataList={ filteredLeadSourceList }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        setFieldValue(name, selectedOption)
        setFieldTouched(name, true, false)
      }}
      { ...props }
    />
  )
}

LeadSourceSelectSearchField.propTypes    = propTypes
LeadSourceSelectSearchField.defaultProps = defaultProps

export default LeadSourceSelectSearchField
